export { default } from './InputLabel';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/InputLabel/index.js
// module id = 370
// module chunks = 121